module.exports = __webpack_public_path__ + "static/media/phi-home.85ed6be3.png";